"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_VENDORS = exports.MIME_SIGNATURE_HASHING_ALGORITHMS = exports.STATUS_FILE_PREFIX = exports.RECIPIENT_CLASS_NAME = exports.SENDER_CLASS_NAME = void 0;
const common_1 = require("../utils/common");
const statuses_pb_1 = require("../generated/statuses_pb");
const SenderStatusObjectMessage = statuses_pb_1.vereign.statuses.SenderStatusObject;
const RecipientStatusDataMessage = statuses_pb_1.vereign.statuses.RecipientStatusData;
const RecipientStatusObjectMessage = statuses_pb_1.vereign.statuses.RecipientStatusObject;
const WrapperDataMessage = statuses_pb_1.vereign.statuses.WrapperData;
exports.SENDER_CLASS_NAME = "SenderStatusObject";
exports.RECIPIENT_CLASS_NAME = "RecipientStatusObject";
exports.STATUS_FILE_PREFIX = "bs_";
exports.MIME_SIGNATURE_HASHING_ALGORITHMS = {
    MIME: "MIME",
    PARTS: "PARTS",
};
exports.EMAIL_VENDORS = {
    GMAIL: "GMAIL",
    OUTLOOK: "OUTLOOK",
    ROUNDCUBE: "ROUNDCUBE",
    GENERIC_MIME: "GENERIC_MIME",
};
class StatusesService {
    encodeSenderStatusObject(senderStatusObject) {
        const senderStatusObjectMessage = SenderStatusObjectMessage.fromObject(senderStatusObject);
        return SenderStatusObjectMessage.encode(senderStatusObjectMessage).finish();
    }
    decodeSenderStatusObject(bytes) {
        const senderStatusObjectMessage = SenderStatusObjectMessage.decode((0, common_1.ensureUint8Array)(bytes));
        return SenderStatusObjectMessage.toObject(senderStatusObjectMessage, {
            bytes: String,
            longs: Number,
            enums: String,
        });
    }
    encodeAndWrapSenderStatusObject(senderStatusObject) {
        const encodedSenderStatusObject = this.encodeSenderStatusObject(senderStatusObject);
        return this.encodeSenderWrapperData(encodedSenderStatusObject);
    }
    encodeRecipientStatusObject(data) {
        const recipientStatusObjectMessage = RecipientStatusObjectMessage.fromObject(data);
        return RecipientStatusObjectMessage.encode(recipientStatusObjectMessage).finish();
    }
    decodeRecipientStatusObject(bytes) {
        const recipientStatusObjectMessage = RecipientStatusObjectMessage.decode((0, common_1.ensureUint8Array)(bytes));
        return RecipientStatusObjectMessage.toObject(recipientStatusObjectMessage, {
            bytes: String,
            longs: Number,
        });
    }
    encodeAndWrapRecipientStatusObject(data) {
        const encodedSenderStatusObject = this.encodeRecipientStatusObject(data);
        return this.encodeRecipientWrapperData(encodedSenderStatusObject);
    }
    encodeRecipientStatusData(data) {
        const recipientStatusDataMessage = RecipientStatusDataMessage.fromObject(data);
        return RecipientStatusDataMessage.encode(recipientStatusDataMessage).finish();
    }
    decodeRecipientStatusData(bytes) {
        const recipientStatusDataMessage = RecipientStatusDataMessage.decode((0, common_1.ensureUint8Array)(bytes));
        return RecipientStatusDataMessage.toObject(recipientStatusDataMessage, {
            bytes: String,
            longs: Number,
        });
    }
    encodeSenderWrapperData(statusObjectBytes) {
        return this.encodeWrapperData(statusObjectBytes, exports.SENDER_CLASS_NAME, 1);
    }
    encodeRecipientWrapperData(statusObjectBytes) {
        return this.encodeWrapperData(statusObjectBytes, exports.RECIPIENT_CLASS_NAME, 1);
    }
    encodeWrapperData(data, className, version = 1) {
        const wrapperDataMessage = WrapperDataMessage.fromObject({
            data,
            className,
            version,
        });
        return WrapperDataMessage.encode(wrapperDataMessage).finish();
    }
    decodeWrapperData(bytes) {
        const wrappedDataMessage = WrapperDataMessage.decode((0, common_1.ensureUint8Array)(bytes));
        return WrapperDataMessage.toObject(wrappedDataMessage, {
            bytes: String,
        });
    }
    decodeStatusObject(wrapperDataBytes) {
        const decodedWrapperData = this.decodeWrapperData(wrapperDataBytes);
        if (decodedWrapperData.className === exports.SENDER_CLASS_NAME) {
            return {
                className: exports.SENDER_CLASS_NAME,
                statusObject: this.decodeSenderStatusObject(decodedWrapperData.data),
            };
        }
        else if (decodedWrapperData.className === exports.RECIPIENT_CLASS_NAME) {
            return {
                className: exports.RECIPIENT_CLASS_NAME,
                statusObject: this.decodeRecipientStatusObject(decodedWrapperData.data),
            };
        }
        else {
            return null;
        }
    }
}
StatusesService.SENDER_CLASS_NAME = exports.SENDER_CLASS_NAME;
StatusesService.RECIPIENT_CLASS_NAME = exports.RECIPIENT_CLASS_NAME;
StatusesService.EMAIL_VENDORS = exports.EMAIL_VENDORS;
StatusesService.MIME_SIGNATURE_HASHING_ALGORITHMS = exports.MIME_SIGNATURE_HASHING_ALGORITHMS;
StatusesService.STATUS_FILE_PREFIX = exports.STATUS_FILE_PREFIX;
exports.default = StatusesService;
